import React from 'react';
import get from 'lodash/get';
import throttle from 'lodash/throttle';

export interface State {
  width?: number;
  height?: number;
}

export interface Props {
  children: (State) => React.ReactNode;
  className?: string;
}

const THROTTLE_TIMEOUT = 100;
const APPEND_STYLES_TIMEOUT = 20;

export default class ContainerSize extends React.Component<Props, State> {
  state = {
    width: undefined,
    height: undefined,
  };
  containerRef;
  mounted;

  componentDidMount() {
    window.addEventListener('resize', this.updateSize);
    this.updateSize();
    this.mounted = true;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);
    this.mounted = false;
  }

  render() {
    const { className, children } = this.props;
    const { width, height } = this.state;

    // this is to fixate container size to ceil'ed values
    const style =
      width && height
        ? {
            width,
            height,
            // padding in such cases is used to set flexible ratio
            // e.g. width 100%, height via padding-top|bottom: calc(100% * 9/6) so that it's relative to width
            // once we fixate the dims, it becomes extraneous
            padding: 0,
          }
        : {};

    return (
      <div style={style} ref={this.saveContainerRef} className={className}>
        {children({ width, height })}
      </div>
    );
  }

  getContainerSize() {
    return {
      width: Math.ceil(get(this.containerRef, 'clientWidth', 0)),
      height: Math.ceil(get(this.containerRef, 'clientHeight', 0)),
    };
  }

  saveContainerRef = ref => {
    this.containerRef = ref;
  };

  updateSize = throttle(
    () =>
      // wait for new stiles present by element queries
      setTimeout(
        () =>
          requestAnimationFrame(() => {
            const size = this.getContainerSize();

            if (
              size.width === this.state.width &&
              size.height === this.state.height
            ) {
              return;
            }

            this.mounted && this.setState(size);
          }),
        APPEND_STYLES_TIMEOUT
      ),
    THROTTLE_TIMEOUT,
    { leading: false }
  );
}
